export const FETCH_ENVS_SUCCESS = 'FETCH_ENVS_SUCCESS';
export const FETCH_ENVS_START = 'FETCH_ENVS_START';
export const FETCH_ENVS_ERROR = 'FETCH_ENVS_ERROR';
export const FETCH_ENVS_END = 'FETCH_ENVS_END';
export const UPDATE_SELECTED_TENANT = 'UPDATE_SELECTED_TENANT';
export const UPDATE_CURRENT_ENV = 'UPDATE_CURRENT_ENV';


